import React, { useState } from 'react';

import { Modal, Toast } from 'src/common/components';

import { createBusinessPhone } from '../api';
import { Action } from '../constants';
import { useAccountProfileContext } from '../context';

type NewBusinessPhoneType = {
  number: string;
  digitsAfterCall: string;
};

const BusinessPhonesCreateModal: React.FC = () => {
  const { state, dispatch } = useAccountProfileContext();
  const [modalInput, setModalInput] = useState<NewBusinessPhoneType>({
    number: '',
    digitsAfterCall: '',
  });
  const { account } = state;
  const { id } = account;
  const isModalPhoneNumberValid = modalInput.number.replace(/\W+/g, '').length === 10;

  const handleCreateBusinessPhone = async (): Promise<void> => {
    try {
      const { number, digitsAfterCall } = modalInput;
      const response = await createBusinessPhone({
        account: id,
        number,
        digits_after_call: digitsAfterCall,
      });
      const { data } = response;
      dispatch({
        type: Action.CREATE_NEW_BUSINESS_PHONE,
        businessPhone: data,
      });
      setModalInput({ number: '', digitsAfterCall: '' });
      Toast.success('The business phone was successfully added.');
    } catch (err) {
      Toast.error('There was an error creating new business phone.');
    }
  };

  const handleSetModalInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setModalInput((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <Modal
      toggleTarget={
        <button
          type="button"
          className="btn btn-secondary font-semibold"
          data-testid="create-business-phone"
        >
          Add business phone
        </button>
      }
      actionFunc={handleCreateBusinessPhone}
      cancelText="Cancel"
      actionText="Yes"
      disabled={!isModalPhoneNumberValid}
    >
      <div>
        <h3>Create new business phone</h3>
        <label htmlFor="number" className="input-label mt-4">
          Number
          <input
            name="number"
            className="input w-full mt-1 transition duration-150 ease-in-out"
            onChange={handleSetModalInput}
            data-testid="number"
            autoComplete="off"
            value={modalInput.number}
          />
          <p className="helper-text"> The number is required and must be 10 digit number.</p>
        </label>
        <label htmlFor="number" className="input-label mt-4">
          Digits after call (optional)
          <input
            name="digitsAfterCall"
            className="input w-full mt-1 transition duration-150 ease-in-out"
            onChange={handleSetModalInput}
            data-testid="digits_after_call"
            autoComplete="off"
            value={modalInput.digitsAfterCall}
          />
          <p className="helper-text"> Used to call extensions or IVR.</p>
        </label>
      </div>
    </Modal>
  );
};

export default BusinessPhonesCreateModal;
